function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useContext, useState } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Heading } from '../../atoms';
import DonationPeriodSwitch from './DonationPeriodSwitch';
import DonationValueSwitch from './DonationValueSwitch';
import ReactConfigContext from '../../ReactConfigContext';
import DonationBoxModal from './DonationBoxModal';
export default function DonationBox(param) {
    var title = param.title, subtitle = param.subtitle, donationTitle = param.donationTitle, initialPeriod = param.initialPeriod, periodOptions = param.periodOptions, valueOptions = param.valueOptions, renderValueDisplayValue = param.renderValueDisplayValue, modal = param.modal, action = param.action, onPeriodChange = param.onPeriodChange, onSelectValue = param.onSelectValue, className = param.className;
    var _useState = _sliced_to_array(useState(false), 2), modalOpen = _useState[0], setModalOpen = _useState[1];
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var handleOpenModal = function handleOpenModal() {
        return setModalOpen(true);
    };
    var handleCloseModal = useCallback(function() {
        return setModalOpen(false);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge('bg-red-500 rounded-md grid grid-cols-1 grid-flow-row auto-rows-max gap-6 py-5 px-6 md:py-7 md:px-8', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-fg-inverted text-center"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title), /*#__PURE__*/ React.createElement(Body, {
        variant: "default"
    }, subtitle)), /*#__PURE__*/ React.createElement(DonationPeriodSwitch, {
        initialValue: initialPeriod,
        options: periodOptions,
        onChange: onPeriodChange
    }), !!modal && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: handleOpenModal
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "default",
        className: "text-fg-inverted text-center underline font-semibold"
    }, modal === null || modal === void 0 ? void 0 : modal.title)), /*#__PURE__*/ React.createElement("div", {
        className: "bg-fg-inverted rounded-xl p-6 text-center grid grid-cols-1 grid-flow-row auto-rows-max gap-6"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, donationTitle), /*#__PURE__*/ React.createElement(DonationValueSwitch, {
        options: valueOptions,
        renderDisplayValue: renderValueDisplayValue,
        onSelect: onSelectValue
    }), !!action && /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge('text-body-small font-semibold text-red-500', action.className)
    }))), !!modal && /*#__PURE__*/ React.createElement(DonationBoxModal, {
        title: modal.title,
        open: modalOpen,
        onClose: handleCloseModal
    }, modal.content));
}

//# sourceMappingURL=DonationBox.js.map